import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { FC, useEffect, useState } from "react";
import { getCookie, setCookie } from "shared/helpers/cookies";
import { AppTester } from "supporting";


const MergeAccountsInfo: FC = () => {
    const profile = useProfile();
    const { info } = useToasts();
    const infoSeen = getCookie('merge_accounts_info_seen');
    const [visible, setVisible] = useState(!infoSeen);

    useEffect(() => {
        if (AppTester.isNewDafesSegment()) {
            return;
        }
        //@ts-ignore
        if (profile && visible && profile.mergeAccountsStatus === 2) {
            info('Если у вас есть несколько аккаунтов, зарегистрированных на разные почтовые адреса, самое время их объединить! Подробнее в профиле.');
            setVisible(false);
            setCookie('merge_accounts_info_seen', true)
        }
    }, [profile, visible, info]);

    if (AppTester.isNewDafesSegment()) {
        return null;
    }

    return (<></>)
}

export default MergeAccountsInfo;

import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { FC, useEffect, useState } from "react";
import { getCookie, setCookie } from "shared/helpers/cookies";
import { AppTester } from "supporting";


const MergeAccountsInfo: FC = () => {
    const profile = useProfile();
    const { info } = useToasts();
    const infoSeen = getCookie('merge_accounts_info_seen');
    const [visible, setVisible] = useState(!infoSeen);

    useEffect(() => {
        if (AppTester.isNewDafesSegment()) {
            return;
        }
        //@ts-ignore
        if (profile && visible && profile.mergeAccountsStatus === 2) {
            info('Если у вас есть несколько аккаунтов, зарегистрированных на разные почтовые адреса, самое время их объединить! Подробнее в профиле.');
            setVisible(false);
            setCookie('merge_accounts_info_seen', true)
        }
    }, [profile, visible, info]);

    if (AppTester.isNewDafesSegment()) {
        return null;
    }

    return (<></>)
}

export default MergeAccountsInfo;

